<template>
  <v-layout
    align-center
    class="checkbox-tag-container"
    :class="`checkbox-tag-container-${color}`"
  >
    <span class="checkbox-tag-checkbox">
      <v-checkbox
        v-model="isSelected"
        :indeterminate="indeterminate"
        :class="[`checkbox-tag-checkbox-icon-${color}`]"
        @change="handleCheckboxClick"
        slot="activator"
      ></v-checkbox>
    </span>
    <span
      class="checkbox-tag-text-container"
      :class="`checkbox-tag-text-container${color}`"
      @click="handleTagClick"
    >
      <AnimatedText v-if="animated" class="checkbox-tag-text" :text="text"></AnimatedText>
      {{ !animated ? text : '' }}
    </span>
  </v-layout>
</template>

<script>
// import '../../../style/_variables.scss'
import AnimatedText from '../AnimatedText.vue'

export default {
  name: 'CheckboxTag',
  components: {AnimatedText},
  props: {
    text: {default: null, type: String},
    selected: {default: true, type: Boolean},
    indeterminate: {default: false, type: Boolean},
    disabled: {default: false, type: Boolean},
    color: {default: 'orange', type: String, validator: (value) => ['orange', 'blue'].includes(value)},
    group: {default: null, type: String},
    animated: {default: true, type: Boolean},
    isSelectAll: {default: false, type: Boolean}
  },
  data () {
    return {
      isSelected: this.selected
    }
  },
  watch: {
    selected: function (val) {
      this.isSelected = val
    }
  },
  methods: {
    handleCheckboxClick () {
      if (this.isSelectAll) {
        this.$emit('selectAllClicked')
        this.$store.commit('updateRelevantKeywordsGroupState', this.group)
      } else {
        this.$store.commit('toggleRelevantKeywordsOrderedTermState', { groupName: this.group, term: this.text })
      }
    },
    handleTagClick () {
      if (!this.isSelectAll) {
        this.isSelected = !this.isSelected
        this.$store.commit('toggleRelevantKeywordsOrderedTermState', {groupName: this.group, term: this.text})
      }
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox-tag {
  &-container {
    border-radius: 8px;
    background-color: $grey-500;
    padding: 2px 5px;
    margin: 3px 7px;
    min-width: min-content;
    max-width: fit-content;
    cursor: pointer;
    &-orange {
      background-color: $warning-400;
    }
    &-blue {
      background-color: $light-blue-400;
      opacity: 1;
    }
  }
  &-checkbox {
    height: 2rem;
    &-icon-orange {
      color: $warning-500 !important;
    }
    &-icon-blue {
      color: $blue-primary !important;
    }
  }
  &-text {
    margin: 0;
    &-container {
      margin: 0 5px;
      text-wrap: nowrap;

      &-orange {
        color: $warning;
      }

      &-blue {
        color: $blue-primary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/buttons/CheckboxTag.vue